module.exports = __webpack_public_path__ + "static/media/jeans.904df96e.png";